import { useLocation } from 'react-router-dom';

export const useCurrentRoute = (): string => {
  const location = useLocation();
  const queryString = location.search || '';
  const currentRoute = location.pathname + queryString;
  return currentRoute;
};
